var map = {
	"./editOrders": [
		"Rpa2",
		2
	],
	"./editOrders.vue": [
		"Rpa2",
		2
	],
	"./rejectOrders": [
		"UXbm",
		1
	],
	"./rejectOrders.vue": [
		"UXbm",
		1
	],
	"./restoreOrder": [
		"9kq7",
		0
	],
	"./restoreOrder.vue": [
		"9kq7",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "chxH";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/components/modals lazy ^\.\/.*$
// module id = chxH
// module chunks = 4